// extracted by mini-css-extract-plugin
export default {"home":"Home_home__GEY+Q","carousel_item":"Home_carousel_item__iZEGj","carousel_icon":"Home_carousel_icon__S57jT","carousel_title":"Home_carousel_title__8mCAW"};